import { render, staticRenderFns } from "./CompliancePlanBadge.vue?vue&type=template&id=bd525c28&"
import script from "./CompliancePlanBadge.vue?vue&type=script&lang=js&"
export * from "./CompliancePlanBadge.vue?vue&type=script&lang=js&"
import style0 from "./CompliancePlanBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports